import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import {
  functionalInterceptor,
  loadingSpinnerInterceptorFunctional,
} from './core/interceptors/functional.interceptor';
import {authenticationInterceptor} from "./core/interceptors/auth.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withFetch()),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([
        loadingSpinnerInterceptorFunctional,
        functionalInterceptor,
        // authenticationInterceptor
      ])
    ),
    // importProvidersFrom(AuthenticationInterceptor)
  ],
};
